<template>
  <div class="tags__main--div">
    <a-select class="default__select--style" mode="tags" :value="selected" placeholder="请选择标签" @change="selectTags" :size="selectSize">
      <a-select-option v-for="item in options" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
    </a-select>
  </div>
</template>
<script>
import projectApi from "@/request/api-manager/project.js";
import CustomTag from './CustomTag'
export default {
  name: 'SelectTags',
  components:{
    CustomTag
  },
  props:{
    defaultSize:{
      type:String,
      default:'default'
    },
    queryParams:{
      type:Object
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
      options:[],
      showStaus:false,
      addTagsParams:{
        delFlag: "0",
        name: "",
        type: 0,
      },
      selectSize:'',

      selected: []
    }
  },
  watch:{
    queryParams(val){
      this.selected = this.selectedList
      // console.log("接受请求的数据",val)
      let {dataType,params} = val
      if (dataType == 'project'){
        this.getProjectTagList(params)
      } else {
        this.getComponentTagList(params)
      }
      
    }
  },
  created(){
    this.selectSize = this.defaultSize
    console.log(this.defaultSize,"this.defaultSize")
    this.$emit('tagFocus')
  },
  methods:{
    /**
     * 获取项目标签
     */
    async getProjectTagList(params){
      // {pageSize:10000,pageNo:1,type:0}
      this.options = []
      this.options = await projectApi.tagList(params).then(res=>{
        // console.log(res.result.records)
        return res.result.records
      })
    },
    /**
     * 获取组件/页面标签
     */
    async getComponentTagList(params){
      console.log(params,"params")
      this.options = []
      this.options = await projectApi.tagList(params).then(res=>{
        // console.log(res.result.records,'recordsrecordsrecords')
        return res.result.records
      })
    },
    selectTags(val){
      let nameArr = []
      this.selected = val

      this.options.map( optionTtem => {
        val.map( valItem => {
          if ( valItem == optionTtem.id ) {
            nameArr.push(optionTtem.name)
          }
        })
      })
      this.$emit("getTags",val)
      this.$emit("getTagsName",nameArr.join(','))
      // console.log(this.selected,nameArr,'this.selected');
    },
    addTagsOptions(val){
      // let params = Object.assign(this.addTagsParams,{
      //   name:val
      // })
      // console.log("添加标签的参数",params)
      // let result = await projectApi.addTag(params).then(res=>{ return res })
      // console.log(result,"添加的结果")
      // if (result.success){ 
      //   this.getTagList()
      //   return this.$message.success("标签添加成功")
      // }
      // return this.$message.error("标签添加失败")
    }
  }
}
</script>
<style lang="less" scoped>
@import "./selectTags.less";
</style>